import {computed, reactive, onMounted, onUnmounted} from 'vue'
import axios from 'axios'
import LxUtils from '../lib/lxutils.js'

const LOCAL_STORE = import.meta.env.VITE_APP_BASE_NAME + '-frontend'

let refreshInterval = null
let idleInterval = null
let logoutInterval = null
let settingsChanged = false
let oldSettings = false
let worker = null

let count = 0
let counter = 0
let counterIdle = 0
// let counterLogout = 0
let refreshing = false

let logoutTimeout = 180000 // 30min bis zum relogin fenster bei idle unabhängig vom token expire

const globalState = reactive({
  someString: "Initial value",
  isLoggedIn: false,
  showReLogin: false,
  userObject: null,
  isIdle: false,
  idleTime: 0,
  counterLogout: 0,
  logoutTimeFrame: 10 // 10min Standard bis zum Re-Login
})

let controller

const startWorker = () => {
  stopWorker()

  worker = new Worker(new URL('./worker.js', import.meta.url));

  worker.onmessage = function (event) {
    if (event.data === 'refresh') {
      refreshToken()
    }
    if (event.data === 'idle') {
      timerIncrement()
    }
    if (event.data === 'logout') {
      showRelogin()
    }
    // singleCheckForExpiredToken()
  };
}

const stopWorker = () => {
  if (worker) {
    worker.terminate();
    worker = null;
  }
};

/**
 * mouse was moved, used isn't idle anymore, set idleTime to 0
 */
function updateByEventListener() {
  globalState.idleTime = 0
  // worker.postMessage({type: 'stopLogout'})
  // worker.postMessage({type: 'stopIdle'})
}

/**
 * Calculate time from getting a token till refresh for a new token
 * Requests are only possible with a valid token, also the request for a new token (refresh)
 *
 * @param expireDate The value, when token is expired
 */
function calculateRepeatTime(expireDate) {
  let begin = new Date()
  let end = new Date(expireDate)
  let duration = end.getTime() - begin.getTime()
  let calcRepeatTime = duration - 60000

  if (calcRepeatTime < 10) {
    calcRepeatTime = 1
  }

  return calcRepeatTime
}

/**
 * addEventlistener and start Intervals
 *  1) refreshInterval -> time till refresh
 *  2) every 1 second to check if idle -> 5 times without mousemove = idle
 * @param repeatTime
 */
function activateIntervals(repeatTime) {
  counter = 0
  counterIdle = 0

  controller = new AbortController()
  // const signal = controller.signal
  const {signal} = controller

  document.addEventListener('beforeinput', updateByEventListener, {signal})
  document.addEventListener('mousemove', updateByEventListener, {signal})
  document.addEventListener("touchstart", updateByEventListener, {signal})

  // refreshInterval = setInterval(refreshToken, repeatTime)
  // idleInterval = setInterval(timerIncrement, 1000)
  if (!worker) {
    startWorker()
  }

  worker.postMessage({type: 'startRefresh', time: repeatTime}) // runs the calculated expire time
  worker.postMessage({type: 'startIdle', time: 1000}) // runs every 1000ms
}

/**
 * deactivate all intervals, is called then logout, relogin or refresh
 */
function deactivateIntervals() {
  // document.removeEventListener('beforeinput', updateByEventListener)
  // document.removeEventListener('mousemove', updateByEventListener)
  // document.removeEventListener("touchstart", updateByEventListener)
  if (controller) {
    controller.abort() //kann alle eventlistener durch "signal" beenden
  }

  if (worker) {
    // clearInterval(refreshInterval)
    worker.postMessage({type: 'stopRefresh'})
    // clearInterval(idleInterval)
    // worker.postMessage('stopIdle')
    worker.postMessage({type: 'stopIdle'})
    // clearInterval(logoutInterval)
    worker.postMessage({type: 'stopLogout'})
  }
}

/**
 * function called every second by idleInterval timer
 */
function timerIncrement() {
  counter++
  let newDateObj = null
  let oldDateObj = JSON.parse(window.sessionStorage.getItem(LOCAL_STORE + '-timer'))
  const user = JSON.parse(window.sessionStorage.getItem(LOCAL_STORE))

  if (!user) {
    showRelogin()
  }

  if (oldDateObj?.time) {
    newDateObj = new Date(new Date(oldDateObj.time).getTime() + oldDateObj.delta)
    let currentDate = new Date()

    if (currentDate > newDateObj) {
      showRelogin()
    }
  }

  globalState.idleTime++

  if (globalState.idleTime > 5) { // 5 sekunden
    counterIdle++
    globalState.isIdle = true

    globalState.counterLogout++

    // if (settingsChanged) {
    //   saveUserSettingsToDatabase()
    //     .then(() => {
    //       settingsChanged = false
    //     })
    //     .catch(() => {
    //     })
    // }

    if (!logoutInterval) {
      globalState.counterLogout = 0
      window.sessionStorage.setItem(LOCAL_STORE + '-timer', JSON.stringify({
        time: new Date(), delta: logoutTimeout * globalState.logoutTimeFrame
      }))
      logoutInterval = true //setInterval(showRelogin, 6000 * globalState.logoutTimeFrame)
      worker.postMessage({type: 'startLogout', time: logoutTimeout * globalState.logoutTimeFrame})
    }
  } else {
    counterIdle = 0
    globalState.counterLogout = 0
    globalState.isIdle = false
    // clearInterval(logoutInterval)
    worker.postMessage({type: 'stopLogout'})
    logoutInterval = null
  }
}

/**
 * Open popup of Re-Login
 */
const showRelogin = () => {
  deactivateIntervals()
  window.sessionStorage.removeItem(LOCAL_STORE + '-timer')
  window.sessionStorage.removeItem(LOCAL_STORE)
  window.sessionStorage.removeItem(LOCAL_STORE + '-tmp-settings')
  globalState.showReLogin = true
}

/**
 * Refresh user token
 */
const refreshToken = () => {
  if (count < 20 && !refreshing) {
    count++
    refreshing = true

    axios.get('/v1/auth/refresh')
      .then((res) => {
        if (res.data?.token) {
          globalState.userObject.token = res.data.token
          globalState.userObject.token_expire = res.data.token_expire

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.token

          window.sessionStorage.setItem(LOCAL_STORE, JSON.stringify(globalState.userObject))
          deactivateIntervals()
          let test = calculateRepeatTime(res.data.token_expire)
          activateIntervals(test)
        }
      })
      .catch(() => {
        // clearInterval(refreshInterval)
        worker.postMessage({type: 'stopRefresh'})

        if (globalState.isLoggedIn) {
          showRelogin()
        } else {
          logoutUser()
        }
      })
      .finally(() => {
        refreshing = false
      })
  }
}

/**
 * Log out user
 *
 * @param goToLogin
 */
const logoutUser = (goToLogin = true) => {
  saveUserSettingsToDatabase()
    .then(() => {
      settingsChanged = false
    })
    .catch(() => {
    })
    .finally(() => {
      globalState.showReLogin = false
      axios.get('/v1/auth/logout')
        .then(() => {
        })
        .catch(() => {
        })
        .finally(() => {
          deactivateIntervals()
          unsetUser()
          axios.defaults.headers.common['Authorization'] = undefined

          if (goToLogin) {
            window.location.href = '/auth/login'
          }
        })
    })
}

/**
 * Delete user in session store and unset user in globalState
 */
const unsetUser = () => {
  globalState.userObject = {}
  globalState.isLoggedIn = false
  window.sessionStorage.removeItem(LOCAL_STORE + '-timer')
  window.sessionStorage.removeItem(LOCAL_STORE)
  window.sessionStorage.removeItem(LOCAL_STORE + '-tmp-settings')
}

/**
 * Save user settings to database
 *
 * @returns {Promise<unknown>}
 */
function saveUserSettingsToDatabase() {
  return new Promise((resolve, reject) => {
    if (settingsChanged) {
      axios.patch('/v1/account/settings', globalState.userObject.user.settings)
        .then((result) => {
          if (result.status === 200) {
            settingsChanged = false
          }
          resolve()
        })
        .catch(() => {
          reject()
        })
    } else {
      reject()
    }
  })
}

startWorker()

export const useStatefulComposable = () => {

  /**
   * Clear tabs value in local settings by location change
   */
  function clearLocalSettingsByLocationChange() {
    const localSettings = JSON.parse(window.sessionStorage.getItem(LOCAL_STORE))
    if (localSettings?.user?.settings_local?.tabs) {
      delete localSettings.user.settings_local.tabs
    }
    window.sessionStorage.setItem(LOCAL_STORE, JSON.stringify(localSettings))
  }

  /**
   * Set global state user and token as header for axios calls
   *
   * @param auth Is true, if call come from App.vue in auth-page
   * @param cb Optionally, function wil be executed, if exists
   */
  const initAuth = (auth, cb) => {
    const user = JSON.parse(window.sessionStorage.getItem(LOCAL_STORE))
    const localSettings = JSON.parse(window.sessionStorage.getItem(LOCAL_STORE + '-tmp-settings'))

    if (user && !auth) {
      // setze den token als header für die axios aufrufe
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.token

      if (user?.user?.settings?.currentLocation) {
        axios.defaults.headers.common['Auth-Domain'] = user.user.settings.currentLocation.id
      }

      if (localSettings && user?.user) {
        user.user['settings_local'] = localSettings.settings
      }

      globalState.userObject = user
      globalState.isLoggedIn = true

      if (cb) {
        cb()
      }

      activateIntervals(calculateRepeatTime(user.token_expire))
    }
  }

  /**
   * Store user after login
   *
   * @param user The logged-in user
   */
  function setUserByLogin(user) {
    return new Promise((resolve) => {
      if (!user.token_expire) {
        console.error('Sie konnten nicht angemeldet werden. Es wurde kein gültiges token_expire übergeben. Achtung: token_expire oder token_expire')
        return
      }

      globalState.userObject = user
      globalState.isLoggedIn = true

      axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.token

      window.sessionStorage.setItem(LOCAL_STORE, JSON.stringify(globalState.userObject))
      let test = calculateRepeatTime(user.token_expire)
      updateByEventListener()
      activateIntervals(test)
      globalState.showReLogin = false

      // window.addEventListener('focus', function (event) {
      // })

      resolve()
    })
  }

  /**
   * Set user location in store and call function to save in as part of settings to database
   *
   * @param location
   */
  function setUserLocation(location) {
    if (location) {
      if (location.id) {
        axios.defaults.headers.common['Auth-Domain'] = location.id
      }

      let temp = {
        settings: {
          currentLocation: location
        }
      }
      /** zweiter parameter "true" ---> update der settings im backend instant, nicht erst nach 5sec idle**/
      updateUserSettings(temp, true)

      // window.location.href = '/main/dashboard'
    }
  }

  let count = 0
  let refreshing = false

  // /**
  //  * Refresh user token
  //  */
  // const refreshToken = () => {
  //   if (count < 20 && !refreshing) {
  //     count++
  //     refreshing = true
  //
  //     axios.get('/v1/auth/refresh')
  //       .then((res) => {
  //         if (res.data?.token) {
  //           globalState.userObject.token = res.data.token
  //           globalState.userObject.token_expire = res.data.token_expire
  //
  //           axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.token
  //
  //           window.sessionStorage.setItem(LOCAL_STORE, JSON.stringify(globalState.userObject))
  //           deactivateIntervals()
  //           let test = calculateRepeatTime(res.data.token_expire)
  //           activateIntervals(test)
  //         }
  //       })
  //       .catch(() => {
  //         clearInterval(refreshInterval)
  //
  //         if (globalState.isLoggedIn) {
  //           showRelogin()
  //         } else {
  //           logoutUser()
  //         }
  //       })
  //       .finally(() => {
  //         refreshing = false
  //       })
  //   }
  // }

  // /**
  //  * Open popup of Re-Login
  //  */
  // const showRelogin = () => {
  //   deactivateIntervals()
  //   window.sessionStorage.removeItem(LOCAL_STORE + '-timer')
  //   window.sessionStorage.removeItem(LOCAL_STORE)
  //   window.sessionStorage.removeItem(LOCAL_STORE + '-tmp-settings')
  //   globalState.showReLogin = true
  // }

  // /**
  //  * Log out user
  //  */
  // const logoutUser = () => {
  //
  //   saveUserSettingsToDatabase()
  //     .then(() => {
  //       settingsChanged = false
  //     })
  //     .catch(() => {
  //     })
  //     .finally(() => {
  //       deactivateIntervals()
  //       unsetUser()
  //
  //       globalState.showReLogin = false
  //       axios.get('/v1/auth/logout')
  //         .then(() => {
  //         })
  //         .catch(() => {
  //         })
  //         .finally(() => {
  //           axios.defaults.headers.common['Authorization'] = undefined
  //           window.location.href = '/auth/login'
  //         })
  //     })
  // }

  /**
   * Check if user has permission (role)
   *
   * @param roles The roles from selected element e.g. navigation
   * @returns {boolean}
   */
  const userHasRole = (roles) => {
    let authUser = globalState.userObject

    if (!roles || !authUser) {
      // allow
      return true
    }

    // get roles
    let domains_roles_location = authUser?.acl?.domains_roles_acl[authUser.user.settings.currentLocation.id]
    let domains_roles_default = authUser?.acl?.domains_roles_acl['*']

    const domains_roles = [].concat(Object.keys(domains_roles_location || {}), Object.keys(domains_roles_default || {}))

    if (!domains_roles) {
      // not allow
      return false
    }

    const filteredArray = domains_roles.filter(value => {
      let test = roles.filter(item => {
        return item === value
      })
      return test.length > 0
    })

    // allow items length > 0
    return filteredArray.length > 0
  }

  // /**
  //  * Delete user in session store and unset user in globalState
  //  */
  // const unsetUser = () => {
  //   globalState.userObject = {}
  //   globalState.isLoggedIn = false
  //   window.sessionStorage.removeItem(LOCAL_STORE + '-timer')
  //   window.sessionStorage.removeItem(LOCAL_STORE)
  //   window.sessionStorage.removeItem(LOCAL_STORE + '-tmp-settings')
  // }

  /**
   * Check, if session already exists
   *
   * @returns {boolean}
   */
  const checkSessionKeyExists = () => {
    const user = JSON.parse(window.sessionStorage.getItem(LOCAL_STORE))
    if (!user) {
      globalState.isLoggedIn = false
    }
    return Boolean(user)
  }

  /**
   * Check if status 401 is jwt error or not enough rights
   */
  const singleCheckForExpiredToken = () => {
    const user = JSON.parse(window.sessionStorage.getItem(LOCAL_STORE))

    if (!user) {
      showRelogin()
    }
    if (globalState.userObject?.token_expire) {
      let remainingTime = calculateRepeatTime(globalState.userObject.token_expire)

      if (remainingTime < 60000) {
        // document.title = 'LOGGED OUT'
        showRelogin()
      }
    }
  }

  /**
   * Lock screen und show re-login popup
   */
  const lockScreen = () => {
    showRelogin()
  }

  // computed

  const showReLoginComp = computed(() => {
    return globalState.showReLogin
  })

  const idleTimeComp = computed(() => {
    return globalState.idleTime
  })

  const counterLogout = computed(() => {
    let tmp = (logoutTimeout / 100) - globalState.counterLogout
    // return { min: ()}
    return {min: Math.floor(tmp / 60), sec: tmp % 60}
  })

  const isLoggedInComp = computed(() => {
    return globalState.isLoggedIn
  })

  const userObjectComp = computed(() => {
    return globalState.userObject?.user
  })

  const userLocationObjectComp = computed(() => {
    return globalState.userObject?.locations
  })

  const isIdleComp = computed(() => {
    return globalState.isIdle
  })

  /** ----------------------------------------------------------- ***/

  // /**
  //  * Save user settings to database
  //  *
  //  * @returns {Promise<unknown>}
  //  */
  // function saveUserSettingsToDatabase() {
  //   return new Promise((resolve, reject) => {
  //     if (settingsChanged) {
  //       axios.patch('/v1/account/settings', globalState.userObject.user.settings)
  //         .then((result) => {
  //           if (result.status === 200) {
  //             settingsChanged = false
  //           }
  //
  //           resolve()
  //         })
  //         .catch(() => {
  //           reject()
  //         })
  //     } else {
  //       reject()
  //     }
  //   })
  // }

  /**
   * Update user settings in store and call function to save in database, if necessary
   *
   * @param value
   * @param instantCall zweiter parameter instantCall === "true" ---> update der settings im backend instant aus nicht erst nach 5sec idle
   */
  function updateUserSettings(value, instantCall) {
    if (globalState.isLoggedIn) {
      globalState.userObject.user = LxUtils.deepMergeObject(globalState.userObject.user, value)
      window.sessionStorage.setItem(LOCAL_STORE, JSON.stringify(globalState.userObject))

      settingsChanged = true

      saveUserSettingsToDatabase()
    }
  }

  /**
   * Update user settings in store without saving in database
   *
   * @param value
   */
  function updateUserSettingsNoDatabase(value) {

    if (globalState.isLoggedIn) {
      globalState.userObject.user = LxUtils.deepMergeObject(globalState.userObject.user, value)
      window.sessionStorage.setItem(LOCAL_STORE, JSON.stringify(globalState.userObject))
    }
  }

  /** ----------------------------------------------------------- ***/

  return {
    singleCheckForExpiredToken,
    checkSessionKeyExists,
    showReLoginComp,
    userObjectComp,
    userLocationObjectComp,
    isLoggedInComp,
    idleTimeComp,
    isIdleComp,
    counterLogout,
    globalState,
    lockScreen,
    updateUserSettings,
    updateUserSettingsNoDatabase,
    initAuth,
    setUserByLogin,
    setUserLocation,
    logoutUser,
    userHasRole,
    clearLocalSettingsByLocationChange
  }
}
